<div class="report-nav">
  <a
    data-pgr-id="report-link"
    *ngFor="let item of data"
    class="cui-link w-16"
    [class.active]="activeHeader === item.anchorId"
    [routerLink]="['/', claimNumberString, 'initial-report']"
    [fragment]="item.anchorId"
  >
    {{ item.anchorlabel }}
  </a>
</div>
